module.exports = __webpack_public_path__ + "static/gallery1-d184bd000ea4c21badcc3acbba4814ba.jpg";